import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Field, change, FieldArrayProps } from 'redux-form';
import { Button, Grid } from 'semantic-ui-react';

// Constants
import { FORM_NAME } from '../../constants';

// Types

// Forms
import {
    normalizers,
    validators,
    RenderField,
    RenderDatePicker
} from '../../../../../../../../forms';

// Normalizers
const { toNumber } = normalizers;

// Validators
const { isRequired, isNotBeforeTwoYearsAgo, isPositiveNumber } = validators;

type Props = FieldArrayProps & {
    change: Function,
    disabled?: boolean,
    forecastedQuantity: number,
    isDifferentFromForecast: boolean
};

class RenderQuantitySchedules extends React.Component<Props> {
    static defaultProps = {
        forecastedQuantity: 0
    };

    componentDidMount() {
        const { fields, forecastedQuantity } = this.props;
        if (!fields.length) {
            fields.push({
                date: null,
                value: forecastedQuantity
            });
        }
    }

    get shouldCalculateForecasts() {
        const { isDifferentFromForecast, forecastedQuantity } = this.props;

        // Don not attempt to calculate forecasts if forecasted quantity does not exist
        if (!forecastedQuantity) {
            return false;
        }

        return !isDifferentFromForecast;
    }

    handleDateFieldChange = (index: number, date: string) => {
        const { fields } = this.props;

        if (index) {
            this.props.change(FORM_NAME, 'isDifferentFromForecast', true);
        } else if (this.shouldCalculateForecasts) {
            this.calculateForecasts(fields.length, date);
        }
    };

    handleValueFieldChange = () => {
        this.props.change(FORM_NAME, 'isDifferentFromForecast', true);
    };

    handleAddClick = () => {
        const { fields } = this.props;

        if (this.shouldCalculateForecasts) {
            // If linked to forecast, calculate new forecasts
            this.calculateForecasts(fields.length + 1);
        } else {
            // Get the last day and add a day to it
            const lastDate = fields.get(fields.length - 1).date;
            fields.push({
                date: moment(lastDate).add(1, 'days').format('YYYY-MM-DD'),
                value: 0
            });
        }
    };

    handleDeleteClick = (index: number) => {
        const { fields } = this.props;

        if (this.shouldCalculateForecasts && index === fields.length - 1) {
            this.calculateForecasts(fields.length - 1);
        } else {
            this.props.change(FORM_NAME, 'isDifferentFromForecast', true);
            fields.remove(index);
        }
    };

    calculateForecasts = (length: number, date?: string) => {
        const { fields, forecastedQuantity } = this.props;
        const startDate = date || (fields.get(0) && fields.get(0).date);
        const quotient = Math.floor(forecastedQuantity / length);
        const remainder = forecastedQuantity % length;
        fields.removeAll();
        for (let index = 0; index < length; index += 1) {
            fields.push({
                date: moment(startDate, 'YYYY-MM-DD')
                    .add(index, 'days')
                    .format('YYYY-MM-DD'),
                value: index === length - 1 ? quotient + remainder : quotient
            });
        }
    };

    render() {
        const { fields, disabled } = this.props;
        return (
            <Grid className="column-padding">
                <Grid.Row>
                    {fields.map((field: string, index: number) => (
                        <React.Fragment key={field}>
                            <Grid.Column width={8}>
                                <Field
                                    label={!index ? 'Date' : undefined}
                                    name={`${field}.date`}
                                    placeholder="Add date"
                                    component={RenderDatePicker}
                                    onChange={(event, date) =>
                                        this.handleDateFieldChange(index, date)
                                    }
                                    validate={[
                                        isRequired,
                                        isNotBeforeTwoYearsAgo
                                    ]}
                                    dateFormat="EEE do MMM"
                                    disabled={disabled}
                                    // disabled={index || disabled}
                                />
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Field
                                    label={!index ? '# Bins' : undefined}
                                    name={`${field}.value`}
                                    type="number"
                                    component={RenderField}
                                    onChange={this.handleValueFieldChange}
                                    normalize={toNumber}
                                    action={
                                        // index === fields.length - 1
                                        index
                                            ? {
                                                  primary: true,
                                                  icon: 'close',
                                                  onClick: () =>
                                                      this.handleDeleteClick(
                                                          index
                                                      ),
                                                  disabled: !index,
                                                  type: 'button'
                                              }
                                            : undefined
                                    }
                                    fluid
                                    disabled={disabled}
                                    validate={isPositiveNumber}
                                    nullOnUnmount={false}
                                />
                            </Grid.Column>
                        </React.Fragment>
                    ))}
                    {!disabled && (
                        <Grid.Column width={16} textAlign="center">
                            <Button
                                type="button"
                                primary
                                circular
                                onClick={this.handleAddClick}
                                disabled={
                                    !(fields.get(0) && fields.get(0).date)
                                }
                            >
                                {'Add pick date'}
                            </Button>
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid>
        );
    }
}

export default connect(null, { change })(RenderQuantitySchedules);
